import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';

export default function FormSectionHeading({ heading }) {
  return (
    <HeadingText
      size="sm"
      className="guest-form-section-heading"
      style={{ marginBottom: '12px' }}
    >
      {heading}
    </HeadingText>
  );
}

FormSectionHeading.propTypes = {
  heading: PropTypes.string,
};
